

import React, { Component, useEffect, useRef, useState } from 'react';
import { ActivityIndicator, Image, ScrollView, Share } from 'react-native';
import { Text, Button, Tab, Tabs, Container, Icon, View, ListItem, Body, Card, CardItem, NativeBaseProvider, Spinner, } from 'native-base';
//import { withNavigationFocus, NavigationEvents } from 'react-navigation';
import { FontAwesome5 } from '@expo/vector-icons';

import db, { getUserPath, signOut } from '../acebase';
import { isLocalDatabase, liveTTScoreboardButtonTextColor, liveTTScoreboardColor } from '../../livettscoreboard.config';
import { liveTTScoreboardTheme } from "../liveTTScoreboardTheme";
import { deleteAllMyTables } from './functions/tables';



export default function MyAccount() {



    return (
        <NativeBaseProvider theme={liveTTScoreboardTheme}>
            <View height="100%" width={"100%"} flex={1} >

                <Text fontSize={"3xl"}>More Coming Soon...</Text>
                <View padding={1}>
                    <Button
                        onPress={() => {
                            signOut()
                        }}
                    >
                        <Text color={liveTTScoreboardButtonTextColor}>Log Out</Text>
                    </Button>
                </View>
                {/* <Button
                    onPress={() => {
                        deleteAllMyTables()
                    }}
                >
                    <Text>Delete My Tables</Text>
                </Button> */}

            </View>
        </NativeBaseProvider>
    )
}